function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import getAmateurRadioInfoByCallsignModules from './modules/getAmateurRadioInfoByCallsign';
import asyncGetAmateurRadioDetailedByCallsignModules from './modules/asyncGetAmateurRadioDetailedByCallsign';
import getAircraftRegistInfoByTailCodeModules from './modules/getAircraftRegistInfoByTailCode';
import asyncGetAirlineInfoByFlightNumberModules from './modules/asyncGetAirlineInfoByFlightNumber';

var Callsign =
/*#__PURE__*/
function () {
  function Callsign() {
    _classCallCheck(this, Callsign);
  }
  /**
   * Search DXCC information for amateur radio callsign
   * @param {String} callsign HamRadio Callsign
   */


  _createClass(Callsign, [{
    key: "getAmateurRadioInfoByCallsign",
    value: function getAmateurRadioInfoByCallsign(callsign) {
      return getAmateurRadioInfoByCallsignModules(callsign);
    }
    /**
     * async Search DXCC information for amateur radio callsign
     * Use promise
     * @param {String} callsign Amateur Callsign
     * @param {String} url Amateur Callsign DataBase Network address
     */

  }, {
    key: "asyncGetAmateurRadioDetailedByCallsign",
    value: function asyncGetAmateurRadioDetailedByCallsign(callsign, url) {
      return asyncGetAmateurRadioDetailedByCallsignModules(callsign, url);
    }
  }, {
    key: "getAmateurRadioDetailedByCallsign",
    value: function getAmateurRadioDetailedByCallsign() {
      console.error('[callsign.js]: API Error \n "getAmateurRadioDetailedByCallsign" only supports Node.js environment, please use "asyncGetAmateurRadioDetailedByCallsign"');
    }
    /**
     * Search attribution based on the Tail code
     * @param {String} tailcode Aircraft Tail Code
     */

  }, {
    key: "getAircraftRegistInfoByTailCode",
    value: function getAircraftRegistInfoByTailCode(tailcode) {
      return getAircraftRegistInfoByTailCodeModules(tailcode);
    }
    /**
     * Get airline information by flight number
     * @param {String} flightnumber Flight Number
     * @param {String} url Flight Number Database
     */

  }, {
    key: "asyncGetAirlineInfoByFlightNumber",
    value: function asyncGetAirlineInfoByFlightNumber(flightnumber, url) {
      return asyncGetAirlineInfoByFlightNumberModules(flightnumber, url);
    }
  }, {
    key: "getAirlineInfoByFlightNumber",
    value: function getAirlineInfoByFlightNumber() {
      console.error('[callsign.js]: API Error \n "getAirlineInfoByFlightNumber" only supports Node.js environment, please use "asyncGetAirlineInfoByFlightNumber"');
    }
  }]);

  return Callsign;
}();

export default new Callsign();